.container {
  background-color: var(--light--container--background-color--1);
  border-radius: 4px;
  border: 1px solid var(--default--border-color--10);
  max-height: 300px;
  overflow: auto;
  width: 350px;
  max-width: 100%;
  box-shadow: 3px 2px 2px var(--dark--box-shadow-color--1);
}

.row {
  white-space: normal;
}

.row-location {
  color: var(--default--text-color--3);
  margin-left: 5px;
}
